import React from "react";
import ListIcon from "@mui/icons-material/List";
import { styled, useTheme } from "@mui/material";
// import hexToRGB from "utils/hexToRGB";

const StyledButton = styled("button")(({ theme }) => ({
    borderRadius: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`,
    margin: 0,
    backgroundColor: theme.palette.secondary.main,
    border: "none",
    width: "32px",
    height: "32px",
    cursor: "pointer",
    "&:hover": {
        backgroundColor: theme.palette.secondary.light,
    },
}));
interface AcxFileButtonProps {
    className?: string;
    onClick: () => void;
}
export default function AcxFileButton(props: AcxFileButtonProps) {
    const theme = useTheme();
    const handleVectorEvents = (e: React.MouseEvent) => {
        if (props.onClick) {
            props?.onClick();
        }
        e.stopPropagation();
    };
    function FileListIcon(props) {
        return (
            <ListIcon
                onClick={handleVectorEvents}
                {...props}
                sx={{ color: theme.palette.white.main, fontSize: "16px" }}
            />
        );
    }
    return (
        <StyledButton onClick={props?.onClick}>
            <FileListIcon fontSize={"small"} />
        </StyledButton>
    );
}
